// Registro das páginas especiais: tipo (`gestao.plano_acao_tarefas.pagina`) → título, fonte e componente.
// Tipo que não está aqui (ex.: servidor mais novo que a tela) cai num aviso em PaginaTarefa.
import Faturamento12m from './Faturamento12m';
import MargemSetor from './MargemSetor';
import Propostas20 from './Propostas20';
import type { DefinicaoPagina } from './tipos';

export type { DefinicaoPagina, PropsPagina } from './tipos';

export const PAGINAS: Record<string, DefinicaoPagina> = {
  propostas_20: { titulo: 'Propostas decididas', fonte: 'comercial', componente: Propostas20 },
  faturamento_12m: { titulo: 'Faturamento', fonte: 'dre', componente: Faturamento12m },
  margem_setor: { titulo: 'Margem por setor', fonte: 'dre', componente: MargemSetor },
};
